import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { applyStoredReferral } from "@/lib/referral";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId }, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        await applyStoredReferral();
        window.history.replaceState(null, "", "/studio");
        navigate("/studio", { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF9F5]">
      <div className="w-12 h-12 rounded-full border-4 border-[#E2D9CC] border-t-[#C85A32] animate-spin" />
      <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-[#9C8F85]">
        Setting your table…
      </p>
    </div>
  );
}
